import type {
    InsightRankedGuestExclusionV4,
    InsightRankedGuestListV4,
    InsightRankedGuestV4,
} from "../../models/crm-v4";
import {
    useExcludeInsightsV2GuestValueProfile,
    useIncludeInsightsV2GuestValueProfile,
    useInsightsV2GuestValueExclusions,
} from "../useInsightsV2Stats";

export function useRankedGuestTableActions(ranking: InsightRankedGuestListV4) {
    const exclusionsQuery = useInsightsV2GuestValueExclusions();
    const excludeMutation = useExcludeInsightsV2GuestValueProfile();
    const includeMutation = useIncludeInsightsV2GuestValueProfile();
    const actionLoading = excludeMutation.isLoading || includeMutation.isLoading;

    return {
        exclusions: exclusionsQuery.data?.filter(exclusion => exclusion.ranking === ranking) ?? [],
        exclusionsLoading: exclusionsQuery.isLoading,
        exclusionsError: exclusionsQuery.isError || excludeMutation.isError || includeMutation.isError,
        actionLoading,
        onExclude: (guest: InsightRankedGuestV4) => {
            excludeMutation.mutate({ranking, profileId: guest.profileId});
        },
        onRestore: (exclusion: InsightRankedGuestExclusionV4) => {
            includeMutation.mutate({ranking: exclusion.ranking, profileId: exclusion.profileId});
        },
    };
}
